import React from 'react';
import FilterSection from '@client/components/search/FilterSection';
import { AGRONOMIC_FILTER_CONFIGS, DOCUMENT_TYPE } from '@client/feature/product/config/filterConfigs';

const Agronomic = ({ filters, onFilterChange }) => {
  return (
    <FilterSection
      filterConfigs={AGRONOMIC_FILTER_CONFIGS}
      filters={filters}
      onFilterChange={onFilterChange}
      document={DOCUMENT_TYPE}
      className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
    />
  );
};

export default Agronomic;
